var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader",style:({ display: _vm.loader ? 'block' : 'none' })},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centrize full-width"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])])])
}]

export { render, staticRenderFns }